import React from "react";
import { Link } from "react-router-dom";
import { dashboardAsset } from "../../utils/dashboardAssets";
import { GATEWAY_MAP_OVERLAYS } from "../../data/dashboardMockData";

const OsharOverviewPanel = () => (
  <section className="dg-panel dg-panel--compact dg-gold-ring dg-premium-ring dg-map-panel">
    <h2 className="dg-panel__title serif">Oshar Overview</h2>
    <p className="dg-label-up dg-muted" style={{ margin: "0 0 6px" }}>
      Illustrative map — not tied to your owned NFTs.
    </p>
    <div className="dg-map-frame">
      <img src={dashboardAsset("06_oshar_overview_map_style.png")} alt="" loading="lazy" />
      {GATEWAY_MAP_OVERLAYS.map((spot) => (
        <span key={spot.label} className="dg-map-tag" style={spot.style}>
          {spot.label}
        </span>
      ))}
    </div>
    <div className="dg-map-actions">
      <Link to="/world/oshar" className="dg-btn dg-btn--blue-outline">
        View World Map
      </Link>
    </div>
  </section>
);

export default OsharOverviewPanel;
